import { z } from "zod";

export const warningObjectSchema = z.object({
	geometry_id: z.string(),
	properties: z.object({
		area_desc: z.string(),
		category: z.string(),
		certainty: z.string(),
		effective: z.number(),
		effective_str: z.string(),
		"event_ar-AR": z.string(),
		"event_en-US": z.string(),
		expires: z.number(),
		expires_str: z.string(),
		layer: z.string(),
		onset: z.number(),
		onset_str: z.string(),
		sender: z.string(),
		sent: z.number(),
		sent_str: z.string(),
		severity: z.string(),
		urgency: z.string(),
		value: z.number(),
		warning_type: z.string(),
		"instruction_ar-AR": z.string(),
		"instruction_en-US": z.string(),
		"description_ar-AR": z.string(),
		"description_en-US": z.string(),
		"headline_ar-AR": z.string(),
		"headline_en-US": z.string(),
	}),
});

export const warningSchema = z.object({
	type: z.string(),
	features: z.array(warningObjectSchema),
});

export type WarningSchema = z.infer<typeof warningObjectSchema>;
